import type { InferKV } from "../types.js";

interface CheckedMap<K, V> extends ReadonlyMap<K, V> {
  get(key: K): V;
}

/**
 * Returns a checked map from the given entries.
 *
 * This is just a typing helper, no runtime check is done here and the returned
 * Map is not "frozen"
 */
export const checkedMapFromEntries = <
  T extends ReadonlyArray<readonly [unknown, unknown]>,
  KV extends InferKV<T>,
>(
  entries: T,
): CheckedMap<KV["k"], KV["v"]> => new Map(entries);
